import { useRef, useEffect } from 'react';
import isEqual from 'lodash/isEqual';

export { default as createReducer } from 'utilities/createReducer';

export function no_op() { }

// Hook
export function useWhyDidYouUpdate(name, props) {
    // Get a mutable ref object where we can store props ...
    // ... for comparison next time this hook runs.
    const previousProps = useRef();
    useEffect(() => {
      if (previousProps.current) {
        // Get all keys from previous and current props
        const allKeys = Object.keys({ ...previousProps.current, ...props });
        // Use this object to keep track of changed props
        const changesObj = {};
        // Iterate through keys
        allKeys.forEach((key) => {
          // If previous is different from current
          if (previousProps.current[key] !== props[key]) {
            // Add to changesObj
            changesObj[key] = {
              from: previousProps.current[key],
              to: props[key],
            };
          }
        });
        // If changesObj not empty then output to console
        if (Object.keys(changesObj).length) {
          console.log("[why-did-you-update]", name, changesObj);
        }
      }
      // Finally update previousProps with current props for next hook call
      previousProps.current = props;
    });
  }

  export function createGUID() {
    const s4 = function () {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    };
    return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
  }

// using for second argument in React.memo
export function areEqual(prevProps, nextProps) {
  return isEqual(prevProps, nextProps);
}

export function getMilesFromMeters(value, decimals = 3) {
  if (typeof value !== 'number') return value;

  return parseFloat((value / 1609.344).toFixed(decimals));
}

export function getMetersFromMiles(value, decimals = 3) {
  if (typeof value !== 'number') return value;

  return parseFloat((value * 1609.344).toFixed(decimals));
}

export function getDiameterFromRadius(radius,  decimals = 3) {
  if (typeof radius !== 'number') return radius;

  return parseFloat((radius * 2 / 1609.344).toFixed(decimals));
}

export function getCircumferenceFromRadius(radius, decimals = 3) {
  if (typeof radius !== 'number') return radius;

  return parseFloat((2 * radius * Math.PI / 1609.344).toFixed(decimals));
}

export function getAreaFromRadius(radius, decimals = 3) {
  if (typeof radius !== 'number') return radius;

  return parseFloat((Math.PI * Math.pow(radius / 1609.344, 2)).toFixed(decimals));
}

export function convertMetersToLatitude(meters) {
  const earth = 6378.137;  //radius of the earth in kilometer
  const pi = Math.PI;
  const m = (1 / ((2 * pi / 360) * earth)) / 1000;  //1 meter in degree

  return meters * m;
}

export function convertMetersToLongitude(meters, latitude) {
  const earth = 6378.137;  //radius of the earth in kilometer
  const pi = Math.PI;
  const cos = Math.cos;
  const m = (1 / ((2 * pi / 360) * earth)) / 1000;  //1 meter in degree

  return (meters * m) / cos(latitude * (pi / 180));
}
